import { Link } from "gatsby";
import { AnimatePresence, motion } from "framer-motion";
import React, { useEffect, useState } from "react";
import { useWindowScroll, useLocation, useWindowSize } from "react-use";
import Logo from "./svg/logo";
import * as styles from "./header.module.scss";
import Mobilelogo from "./mobilelogo";

function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const [isHide, setIsHide] = useState(false);
  const [isWhite, setIsWhite] = useState(false);

  const { height, width } = useWindowSize();
  const location = useLocation();
  const { y } = useWindowScroll();

  useEffect(() => {
    if (location.pathname === "/" && width <= 1024) {
      if (height > y) {
        setIsHide(true);
      } else {
        setIsHide(false);
      }
    } else if (location.pathname === "/" && width > 1024) {
      if (height * 2 > y) {
        setIsWhite(true);
      } else {
        setIsWhite(false);
      }
    } else return;
  }, [location, y, width, height]);

  useEffect(() => {
    setIsOpen(false);
  }, [location]);

  return (
    <header className={styles.container}>
      <motion.nav
        animate={{
          opacity: isHide ? 0 : 1,
          y: isHide ? "150%" : 0,
          transition: { duration: 0.6, ease: [0, 0, 0.27, 0.89] },
        }}
        className={styles.nav}
      >
        <Link className={styles.logo} to="/">
          {width > 1024 ? <Logo /> : <Mobilelogo isHide={isHide} />}
        </Link>
        <div className={styles.line} />
        <div className={styles.menu}>
          <button
            className={styles.button}
            style={{ color: isOpen || isWhite ? "white" : "#010a27" }}
            onClick={() => setIsOpen(!isOpen)}
          >
            <p>Меню</p>
            <div className={styles.icon}>
              <motion.div
                animate={{
                  rotateZ: isOpen ? 45 : 0,
                  y: isOpen ? "0.5rem" : 0,
                }}
                className={styles.iconline}
              />
              <motion.div
                animate={{
                  opacity: isOpen ? 0 : 1,
                  x: isOpen ? "25%" : 0,
                }}
                className={styles.iconline}
              />
              <motion.div
                animate={{
                  rotateZ: isOpen ? -45 : 0,
                  y: isOpen ? "-0.5rem" : 0,
                }}
                className={styles.iconline}
              />
            </div>
          </button>
          <AnimatePresence initial={false} mode="wait">
            {isOpen && (
              <div className={styles.navcontainer}>
                <motion.div
                  initial={{
                    backgroundColor: "rgba(245, 245, 245, 0)",
                  }}
                  animate={{
                    backgroundColor: "rgba(245, 245, 245, 0.5)",
                  }}
                  exit={{
                    backgroundColor: "rgba(245, 245, 245, 0)",
                  }}
                  className={styles.background}
                  onClick={() => setIsOpen(false)}
                />
                <motion.div
                  initial={{
                    clipPath:
                      width > 1024
                        ? "circle(0% at 100% 0%)"
                        : "circle(0% at 100% 100%)",
                  }}
                  animate={{
                    clipPath:
                      width > 1024
                        ? "circle(150% at 100% 25%)"
                        : "circle(150% at 100% 75%)",
                    transition: { duration: 0.6, ease: [0.5, 0, 0.5, 0.9] },
                  }}
                  exit={{
                    clipPath:
                      width > 1024
                        ? "circle(0% at 100% 0%)"
                        : "circle(0% at 100% 100%)",
                    transition: { duration: 0.4, ease: [0.5, 0, 0.5, 0.9] },
                  }}
                  className={styles.navlist}
                >
                  <motion.div
                    initial={{ opacity: 0, y: 8 }}
                    animate={{
                      opacity: 1,
                      y: 0,
                      transition: {
                        delay: 0.2,
                        duration: 0.8,
                        ease: [0.5, 0, 0.5, 0.9],
                      },
                    }}
                    className={styles.block}
                  >
                    <Link to="/" className={styles.link}>
                      Главная
                    </Link>
                    <Link to="/about" className={styles.link}>
                      О нас
                    </Link>
                    <Link to="/ceilings" className={styles.link}>
                      Натяжные потолки
                    </Link>
                    <Link to="/ceilings" className={styles.sublink}>
                      Технологии
                    </Link>
                    <Link to="/ceilings" className={styles.sublink}>
                      Фактура
                    </Link>
                  </motion.div>
                  <motion.div
                    initial={{ opacity: 0, y: 10 }}
                    animate={{
                      opacity: 1,
                      y: 0,
                      transition: {
                        delay: 0.3,
                        duration: 0.8,
                        ease: [0.5, 0, 0.5, 0.9],
                      },
                    }}
                    className={styles.block}
                  >
                    <p className={styles.title}>Доп услуги</p>
                    <button className={styles.sublink}>Выезд на замер</button>
                    <button className={styles.sublink}>Обслуживание</button>
                    <button className={styles.sublink}>Ремонт потолка</button>
                    <button className={styles.sublink}>Слив воды</button>
                  </motion.div>
                  <motion.div
                    initial={{ opacity: 0, y: 12 }}
                    animate={{
                      opacity: 1,
                      y: 0,
                      transition: {
                        delay: 0.4,
                        duration: 0.8,
                        ease: [0.5, 0, 0.5, 0.9],
                      },
                    }}
                    className={styles.block}
                  >
                    <p className={styles.title}>Контакты</p>
                    <a
                      className={styles.sublink}
                      href="tel:+73912412363"
                      target="_blank"
                      rel="noreferrer"
                    >
                      241-23-63
                    </a>
                    <a
                      className={styles.sublink}
                      href="https://wa.me/79535983007"
                      target="_blank"
                      rel="noreferrer"
                    >
                      WhatsApp
                    </a>
                    <a
                      className={styles.sublink}
                      target="_blank"
                      rel="noreferrer"
                      href="https://yandex.ru/maps/62/krasnoyarsk/house/krasnodarskaya_ulitsa_40_1/bUsYfwNgT0MHQFtsfXx0cn9rZQ==/?ll=92.940359%2C56.052787&z=18.39"
                    >
                      Краснодарская 40/1 офис
                    </a>
                  </motion.div>
                </motion.div>
              </div>
            )}
          </AnimatePresence>
        </div>
      </motion.nav>
    </header>
  );
}

export default Header;
